import React from 'react';
import { stylePropType, childrenPropType, TSS_DARK_BLUE } from 'tss-core-lib-common';

import { css, StyleSheet } from '../styling';

var styles = void 0;

var Spinner = function Spinner(_ref) {
  var style = _ref.style,
      children = _ref.children;
  return React.createElement(
    'div',
    { className: css(styles.container) },
    React.createElement('span', { className: css(styles.spinner, style) }),
    children
  );
};

Spinner.propTypes = {
  style: stylePropType,
  children: childrenPropType
};

Spinner.defaultProps = {
  style: null,
  children: null
};

styles = StyleSheet.create({
  container: {
    display: 'flex',
    alignItems: 'center',
    fontSize: '1.4rem',
    color: TSS_DARK_BLUE(0.6),

    '>:nth-child(2)': {
      marginLeft: '1.6rem'
    }
  },

  spinner: {
    width: '0.4rem',
    height: '2rem',
    right: '2rem',
    backgroundColor: TSS_DARK_BLUE(),
    animationName: [{
      from: {
        transform: 'rotate(0deg)'
      },
      to: {
        transform: 'rotate(360deg)'
      }
    }],
    animationDuration: '0.8s',
    animationIterationCount: 'infinite'
  }
});

export default Spinner;